import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Error404Box } from 'components/error-handle/errors';

export function VideoBoxError() {
  const { t } = useTranslation();

  return (
    <Error404Box>
      <h1>{t('requested_video_not_found')}</h1>
      <p>{t('video_not_found_message')}</p>
      <p>
        {t('return_to') + ' '}
        <Link to="/">{t('home')}</Link>
      </p>
      <span>{t('error_404')}</span>
    </Error404Box>
  );
}
